import React, { useEffect, useState } from "react"
import { Btn } from "../components/Btn.tsx";
import { formatDate, formatPrice, Schema } from "../utils";
import { Loader } from "../components/Loader.tsx";
import { useCore } from "../hooks";
import { useNavigate, useParams } from "react-router";
import { CheckoutClosing } from "depoto-core";
import { OrderFinalSummary, VatAllocationsTable } from "../components";

export const CheckoutClosingDetail: React.FC = () => {
  const params = useParams()
  const navigate = useNavigate()
  const { core, currency } = useCore()
  const [checkoutClosing, setCheckoutClosing] = useState<CheckoutClosing>()

  useEffect(() => {
    if (params?.id) {
      getClosing(Number(params.id))
    }
  }, [params])

  const getClosing = async (closingId: number) => {
    const c = await core.services.checkout.getCheckoutClosingById(closingId, Schema.checkoutClosing.detail)
    setCheckoutClosing(c)
  }

  const backToList = () => {
    navigate('/checkout-detail/checkout-closings')
  }

  const showPdf = () => {
    core.services.download.downloadDocumentAndShowInNewWindow(checkoutClosing.billUrl, false)
  }

  return checkoutClosing ? (
    <div className="h-body p-6 flex flex-col overflow-y-auto">
      <div className="bg-white border-b-1 border-solid border-border-light rounded-md p-6 mb-6">
        <div className="flex flex-row items-center">
          <div className="flex flex-row items-center">
            <h1 className="font-bold mr-4 text-xl">Uzávěrka pokladny {checkoutClosing.checkout.name}</h1>
            <Btn className="btn-base-100" children={'Zpět na výpis'} icon={'fa-arrow-left'} onClick={backToList} />
          </div>
          <div className="text-lg font-bold ml-auto">
            {checkoutClosing.amountClosed > checkoutClosing.amountRealClosed ? 'PŘEBYTEK'
              : checkoutClosing.amountClosed < checkoutClosing.amountRealClosed ? 'MANKO'
                : checkoutClosing.amountClosed === checkoutClosing.amountRealClosed ? 'STAVY SOUHLASÍ'
                  : null}
          </div>
        </div>
        <div className="flex flex-row border-t border-base-200 mt-4 pt-4">
          <Btn className="btn-base-100" children={'Stáhnout v Pdf'} icon={'far fa-file-pdf'} onClick={showPdf} />
        </div>
      </div>
      <div className="grid grid-cols-2 gap-4 w-8/12">
        <div className="bg-white border-b-1 border-solid border-border-light rounded-md p-6">
          <h3 className="font-semibold text-lg mb-4">Otevření pokladny</h3>
          <div className="space-y-1">
            <div className="flex justify-between">
              <span className="font-bold">Pokladní:</span>
              <span className="font-medium">{checkoutClosing.userOpen?.email}</span>
            </div>
            <div className="flex justify-between">
              <span className="font-bold">Datum otevření:</span>
              <span className="font-medium">{checkoutClosing.dateOpen?.length ? formatDate(new Date(checkoutClosing.dateOpen), false, true) : ''}</span>
            </div>
            <div className="flex justify-between">
              <span className="font-bold">Zapsaný stav:</span>
              <span className="font-medium">{formatPrice(checkoutClosing.amountOpen || 0, currency.id)}</span>
            </div>
            <div className="flex justify-between">
              <span className="font-bold">Skutečný stav:</span>
              <span className="">{formatPrice(checkoutClosing.amountRealOpen || 0, currency.id)}</span>
            </div>
          </div>
        </div>

        <div className="bg-white border-b-1 border-solid border-border-light rounded-md p-6">
          <h3 className="font-semibold text-lg mb-4">Uzavření pokladny</h3>
          <div className="space-y-1">
            <div className="flex justify-between">
              <span className="font-bold">Pokladní:</span>
              <span className="">{checkoutClosing.userClosed?.email}</span>
            </div>
            <div className="flex justify-between">
              <span className="font-bold">Datum uzavření:</span>
              <span className="">{checkoutClosing.dateClosed?.length ? formatDate(new Date(checkoutClosing.dateClosed), false, true) : ''}</span>
            </div>
            <div className="flex justify-between">
              <span className="font-bold">Zapsaný stav:</span>
              <span className="">{formatPrice(checkoutClosing.amountClosed || 0, currency.id)}</span>
            </div>
            <div className="flex justify-between">
              <span className="font-bold">Skutečný stav:</span>
              <span className="">{formatPrice(checkoutClosing.amountRealClosed || 0, currency.id)}</span>
            </div>
          </div>
        </div>

        <div className="bg-white border-b-1 border-solid border-border-light rounded-md p-6">
          <h3 className="font-semibold text-lg mb-4">Operace</h3>
          <div className="space-y-2">
            {checkoutClosing.paymentSum.map((ps, i) => (
              <div key={`payment-sum-${i}`} className="pb-0">
                <div className="flex justify-between items-center mb-0">
                  <span className="">{ps.payment.name}:</span>
                  <span className="font-bold">{ps.count}x</span>
                </div>
                <div className="flex justify-between">
                  <span className="">Částka:</span>
                  <span className="font-bold">{formatPrice(ps.sum, currency.id)}</span>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="bg-white border-b-1 border-solid border-border-light rounded-md p-6">
          <h3 className="font-semibold text-lg mb-4">Vyčíslení DPH</h3>
          <div className="overflow-x-auto">
            <VatAllocationsTable vatAllocations={checkoutClosing.vatAllocations} currency={currency} />
          </div>
        </div>
      </div>
    </div>
  ) : <Loader />
}
